import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {LOCAL_STORAGE, SESSION_STORAGE, StorageService} from 'ngx-webstorage-service';
import {finalize} from 'rxjs/operators';
import {AlertService} from 'ngx-alerts';
import {NgxSpinnerService} from 'ngx-spinner';
import {DashboardService} from '../../../../services/dashboard.service';

@Component({
  selector: 'app-add-update-team-user',
  templateUrl: './add-update-team-user.component.html',
  styleUrls: ['./add-update-team-user.component.scss']
})
export class AddUpdateTeamUserComponent implements OnInit {

  dataForm: FormGroup;
  loggedInUser: any;
  roles: any[] = [];
  submitted = false;

  constructor(public dialogRef: MatDialogRef<AddUpdateTeamUserComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, @Inject(LOCAL_STORAGE) private storage: StorageService,
              private alertService: AlertService, private formBuilder: FormBuilder,
              private spinner: NgxSpinnerService, public dashboardService: DashboardService) {
    this.loggedInUser = storage.get('gs-loggedInUser');
  }

  ngOnInit(): void {
    this.buildDataForm();
    this.getRoles();
  }


  private buildDataForm() {
    this.dataForm = this.formBuilder.group({
      userName: ['', Validators.required],
      channelId: [this.loggedInUser.channelId, Validators.required],
      type: ['Service Center', Validators.required],
      userEmail: ['', Validators.compose([
        Validators.required,
        Validators.email
      ])],
      userPhoneNumber: ['', Validators.compose([
        Validators.minLength(10),
        Validators.maxLength(10),
        Validators.required,
        Validators.pattern(/^[0-9]{10,12}$/)
      ])],
      roleId: ['', Validators.required],
      branchName: ['', Validators.required],

    });
  }

  get form() {
    return this.dataForm.controls;
  }

  addTeamMember() {
    this.spinner.show();
    this.submitted = true;
    this.dashboardService.addTeamMember(this.dataForm.value).pipe(finalize(() => this.spinner.hide())).subscribe(
      (res: any) => {
        this.alertService.success(res.message);
        this.dialogRef.close();
      }, error1 => {
        console.error(error1);
        this.alertService.danger(error1.message ? error1.message : error1);
      }
    );

  }

  private getRoles() {
    this.spinner.show();
    this.dashboardService.getRoles().pipe(finalize(() => this.spinner.hide())).subscribe(
      (res: any) => {
        this.roles = res.roles;
      }, error1 => {
        console.error(error1);
        this.alertService.danger(error1.message ? error1.message : error1);
      }
    );
  }

}
